import React, { useCallback } from "react";
import { useForm } from "react-hook-form";
import styled from "styled-components";
import useEditControlls from "../../../modules/admin/hooks/use-edit-controlls";

type Props = {}

const Container = styled.div`
    border-bottom: 1px solid #9d9d9d;

    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: stretch;

    &>* {
        padding: .5em;
    }

    .description {
        font-weight: bold;
    }

    .change {
        position: relative;
        min-width: 5em;
        text-align: center;
        padding: 0;
    }

    label {
        display: flex;
        width: 100%;
        height: 100%;
        cursor: pointer;
        justify-content: center;
        align-items: center;

        input {
            display: inline-block;
            cursor: pointer;
        }

        &:hover {
            background: #9d9d9d;
        }
    }
`;

const EditControlls: React.FC<Props> = () => {
    const { status, open, close, isLoading } = useEditControlls();
    const { register, handleSubmit } = useForm();

    const onSubmit = useCallback((data) => {
        if (data.editStatus) {
            open();
        } else {
            close();
        }
    }, [open, close]);

    return <form onSubmit={handleSubmit(onSubmit)}>
        <Container>
            <div className="description">
                Czy edycja bibliotek jest włączona?
            </div>
            <div className="status">
                {status ? 'Edycja bibliotek włączona (każdy kto zna adres może edytować)' : 'Edycja bibliotek wyłączona (tylko zalogowani admini mogą edytować)'}
            </div>
            <div className="change">
                {isLoading && <p>Ładowanie</p>}
                {!isLoading &&
                    <label>
                        <input type="checkbox" defaultChecked={status} {...register('editStatus')} />
                    </label>
                }
            </div>
            <div className="save">
                <button>Zapisz</button>

            </div>
        </Container >
    </form>
}


export default EditControlls;
